import React, { useEffect, useRef } from 'react';
import { useActionModalContent } from '../../../slice';
import './actionModal.scss';

function ActionModalRoot() {
    const modalRef = useRef(null);
    const modalContent = useActionModalContent() || {};

    const {
        visible,
        onRequestClose,
        header,
        body,
        footer,
        headerIconLeft,
        headerIconRight,
        headerRightAction = () => {},
    } = modalContent;

    useEffect(() => {
        const handleClickOutside = event => {
            // Only close if clicking outside the modal content
            // Check if the click target is not inside the modal content
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                // Also verify it's actually on the backdrop, not somewhere else on the page
                const backdrop = event.target.closest('.action-modal-backdrop');
                if (backdrop) {
                    onRequestClose?.();
                }
            }
        };

        if (visible) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visible, onRequestClose]);

    const onRightAction = () => {
        onRequestClose?.();
        headerRightAction();
    };

    if (!visible) return null;

    const handleBackdropClick = e => {
        // Only close if clicking directly on the backdrop (not on any child)
        if (e.target === e.currentTarget) {
            onRequestClose?.();
        }
    };

    return (
        <div className="action-modal-backdrop" onClick={handleBackdropClick}>
            <div
                className="action-modal-content"
                ref={modalRef}
                onClick={e => e.stopPropagation()}
                onMouseDown={e => e.stopPropagation()}
            >
                {(headerIconLeft || header || headerIconRight) && (
                    <div className="action-modal-header">
                        {headerIconLeft && (
                            <div className="action-modal-header-icon">
                                <button type="button" onClick={onRequestClose}>
                                    {headerIconLeft}
                                </button>
                            </div>
                        )}
                        {header && <h3 className="action-modal-title">{header}</h3>}
                        {headerIconRight && (
                            <button onClick={onRightAction} className="action-modal-header-icon">
                                {headerIconRight}
                            </button>
                        )}
                    </div>
                )}
                {body && <div className="action-modal-body">{body}</div>}
                {footer && <div className="action-modal-footer">{footer}</div>}
            </div>
        </div>
    );
}

export default ActionModalRoot;
